// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__3x84E","Label":"BuildControl_Label__3rEFa","Less":"BuildControl_Less__i-GXU","More":"BuildControl_More__Szuld"};